module.exports = __webpack_public_path__ + "static/img/mr.c969d069.png";